import { observer } from "mobx-react";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import AHref from "../../../../../../../components/ahref/ahref";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    QRImage: { url: string | null, title: string };
};

const QRCell: React.FC<IProps> = observer(({ QRImage }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    return (
        <>
            <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('QR_BARCODE', pageScope)}</FontBody3>
            {!!QRImage.url
                ? (
                    <AHref href={QRImage.url} target="_blank">
                        <FontBody3 color={FONT_COLOR.ACCENT1}>{getTranslation(QRImage.title, pageScope)}</FontBody3>
                    </AHref>
                )
                : <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{getTranslation('QR_NOT_GENERATED', pageScope)}</FontBody3>
            }
        </>
    );
});

export default QRCell;